import { render, staticRenderFns } from "./RentalList.vue?vue&type=template&id=371ddf70&scoped=true&"
import script from "./RentalList.vue?vue&type=script&lang=js&"
export * from "./RentalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371ddf70",
  null
  
)

export default component.exports